module.exports = __webpack_public_path__ + "static/media/about.1bed2098.jpg";